module.exports = __webpack_public_path__ + "img/00036.123c6546.webp";